import levenshtein from "./js-levenshtein.js";
const dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

function isValidFraction(str) {
  let arr = str.split("/");
  return arr.length === 2 && !isNaN(arr[0]) && !isNaN(arr[1])
}

function gcd(a, b) {
  if (b === 0) return a;
  return gcd(b, a % b)
}

function getFractionValue(str) {
  return str.indexOf("/") !== -1 ? Number(str.split("/")[0]) / Number(str.split("/")[1]) : Number(str);
}

export default class FillTheBlanksQuiz {
  constructor({
                question = [],
                ftbType = "capsule",
                answers = [],
                wrongAnswers = "",
              } = {}) {
    this.ftbType = ftbType;
    this.question = question;
    this.answers = answers.filter(a => a).map(a => this.answerByType(a, ftbType));
    this.wrongAnswers = wrongAnswers.split(";").filter(a => a).map(a => a.trim()).join(";");
  }

  answerByType(a, type) {
    switch (type) {
      case "capsule": {
        return new FtbQuizCapsule(a);
      }
      case "input": {
        return new FtbQuizText(a);
      }
      default: {
        break;
      }
    }
  }
}

class FtbQuizCapsule {
  constructor({
                value = "",
              } = {}) {
    this.type = "capsule";
    this.value = value;
  }
}

class FtbQuizText {
  constructor({
                value = "",
                entryType = "text",
                roundToN = 1,
                levenshtein = 1,
                lowestTerms = false,
                caseSensitive = false
              } = {}) {
    this.type = "input";
    this._value = value.split(';').map(s => s.trim()).join(";");
    this.entryType = entryType;
    this.roundToN = roundToN;
    this.levenshtein = levenshtein;
    this.lowestTerms = lowestTerms;
    this.caseSensitive = caseSensitive;
    this.parseAnswerString();
  }

  toJSON() {
    return {
      type: "input",
      lowestTerms: this.lowestTerms,
      caseSensitive: this.caseSensitive,
      value: this.value,
    }
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.parseAnswerString();
  }

  parseAnswerString() {
    let arr = this._value.toString().split(';');
    let val = arr[0];
    if (!isNaN(Number(val.replace(",", ".")))) {
      this._value = Number(val.replace(",", ".")).toString()
      this.entryType = Number(val) === Math.round(Number(val)) ? "integer" : "float";
      this.roundToN = this.entryType === "float" ? this.value.split(".")[1].length : this.roundToN;
    } else if (!isNaN(Number(val.split("/")[0])) && !isNaN(Number(val.split("/")[1]))) {
      this._value = `${Number(val.split("/")[0])}/${Number(val.split("/")[1])}`
      this.entryType = 'fraction'
    } else {
      this._value = arr.join(";");
      this.entryType = "text"
    }
    return this;
  }

  validate(inputVal) {
    let validationMessage = null;
    switch (this.entryType) {
      case "text" : {
        inputVal = this.caseSensitive ? inputVal : inputVal.toLowerCase();
        let synonyms = this.value.split(";").map(s =>  this.caseSensitive ? s : s.toLowerCase());
        if (synonyms.every(s => levenshtein(inputVal, s) > 0) && synonyms.map(s => levenshtein(inputVal, s) <= (s.length <= 5 ? 1 : 2)).filter(b => b).length) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            type: "warn",
            text: "Check your spelling. Try again."
          }
        } else if (synonyms.every(s => levenshtein(inputVal, s) > (s.length <= 5 ? 1 : 2))) {
          validationMessage = {
            valid: false,
            color: "#FF0000",
            type: "wrong",
            text: "Incorrect answer"
          }
        } else {
          validationMessage = {
            valid: true,
            color: "#30C975",
            type: "correct",
            text: "Correct answer"
          }
        }
        break;
      }
      case "integer" : {
        if (isNaN(Number(inputVal)) || Number(inputVal) !== Math.round(Number(inputVal))) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            text: "Use only integer numbers. Try again."
          }
        } else if (inputVal !== this.value) {
          validationMessage = {
            valid: false,
            color: "#FF0000",
            type: "wrong",
            text: "Incorrect answer"
          }
        } else {
          validationMessage = {
            valid: true,
            color: "#30C975",
            type: "correct",
            text: "Correct answer"
          }
        }
        break
      }
      case "float" : {
        inputVal = inputVal.replace(",", ".");
        if (isNaN(Number(inputVal))) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            type: "warn",
            text: "Use only float numbers. Try again."
          }
        } else if ((inputVal.split(".")[1] || "").length !== this.roundToN) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            type: "warn",
            text: `Round to ${dg[this.roundToN]} decimal${this.roundToN > 1 ? "s" : ""}`
          }
        } else if (inputVal !== this.value) {
          validationMessage = {
            valid: false,
            color: "#FF0000",
            type: "wrong",
            text: "Incorrect answer"
          }
        } else {
          validationMessage = {
            valid: true,
            color: "#30C975",
            type: "correct",
            text: "Correct answer"
          }
        }
        break
      }
      case "fraction" : {
        if (inputVal.indexOf("/") === -1) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            type: "warn",
            text: "Fraction must contain \"/\". Try again"
          }
        } else if (isValidFraction(inputVal) && gcd(Number(inputVal.split("/")[0]), Number(inputVal.split("/")[1])) > 1 && this.lowestTerms) {
          validationMessage = {
            valid: false,
            color: "#FFA000",
            type: "warn",
            text: `Write as lowest term. Try again.`
          }
        } else if (getFractionValue(inputVal) !== getFractionValue(this.value)) {
          validationMessage = {
            valid: false,
            color: "#FF0000",
            type: "wrong",
            text: "Incorrect answer"
          }
        } else {
          validationMessage = {
            valid: true,
            color: "#30C975",
            type: "correct",
            text: "Correct answer"
          }
        }
        break
      }
      default: break;
    }

    return validationMessage
  }

}
